import React from 'react';
import PropTypes from 'prop-types';

import { View } from '../../../../../../shared/components';
import Text from '../../../../../../shared/components/Text';
import Tag from '../../../../../../shared/components/Tag';

import { styleUtils } from '../../../../../../shared/utils';

import styles from './styles';

const { style } = styleUtils;

const AddOnItemContainer = style(View, styles.addOnItemContainer);
const TopContainer = style(View, styles.topContainer);
const Title = style(Text);
const DescriptionContainer = style(View, styles.descriptionContainer);
const Description = style(Text);
const BottomContainer = style(View);
const RemoveContainer = style(View, styles.removeContainer);
const RemoveLabel = style(Text, styles.removeLabel);

const AddOnItem = ({
  t,
  type,
  title,
  tag,
  description,
  children,
  showRemove,
  removeText,
  onRemove
}) => {
  const isTextArea = type === 'textArea';
  return (
    <AddOnItemContainer isTextArea={isTextArea} showRemove={showRemove}>
      <TopContainer isTextArea={isTextArea}>
        <Title size="xlarge">{title}</Title>
        {!isTextArea && <Tag>{tag}</Tag>}
      </TopContainer>
      {!isTextArea && (
        <DescriptionContainer>
          <Description>{description}</Description>
        </DescriptionContainer>
      )}
      <BottomContainer>{children}</BottomContainer>
      {!isTextArea && showRemove && (
        <Remove t={t} text={removeText} onClick={onRemove} />
      )}
    </AddOnItemContainer>
  );
};

const Remove = ({ t, onClick, text }) => (
  <RemoveContainer>
    <RemoveLabel onClick={onClick}>{text || t('remove')}</RemoveLabel>
  </RemoveContainer>
);

AddOnItem.propTypes = {
  t: PropTypes.func,
  type: PropTypes.string,
  title: PropTypes.string,
  tag: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.object,
  showRemove: PropTypes.bool,
  removeText: PropTypes.string,
  onRemove: PropTypes.func
};

export default AddOnItem;
